import Select from '@sats-group/ui-lib/react/select';
import TextInput from '@sats-group/ui-lib/react/text-input';
import React, { useState } from 'react';
import type { CountryCodeSelect as Props } from './country-code-select.types';

const CountryCodeSelect: React.FC<Props> = ({
  defaultPattern,
  input,
  patterns,
  prefix,
}) => {
  const [pattern, setPattern] = useState(defaultPattern);
  const handleChange = (key: string) =>
    setPattern(patterns[key] ?? defaultPattern);

  return (
    <React.Fragment>
      <Select
        {...prefix}
        isLabelVisible={true}
        onChange={e => handleChange(e.target.value)}
        required
      />
      <TextInput {...input} pattern={pattern} type="tel" />
    </React.Fragment>
  );
};

export default CountryCodeSelect;
